import styled from 'styled-components';
import { body1, body2, colors, fontWeights, heading4, spacing } from 'ui/theme';

export const StyledTextHeader = styled.div`
  ${heading4};
`;

export const StyledCardHeader = styled(StyledTextHeader)`
  padding: ${spacing.base} ${spacing.plusHalf};
`;

export const CardDetailsGrid = styled.div`
  background: ${colors.white};
  display: grid;
  grid-template-columns: 1fr;
  column-gap: ${spacing.x3};
  align-items: center;
  padding: ${spacing.base} ${spacing.plusHalf} ${spacing.plusHalf} ${spacing.plusHalf};
  grid-template-rows: repeat(auto-fill, ${spacing.x3});
  width: 100%;
  @media (min-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const StyledExperimentDetailsItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  column-gap: ${spacing.x3};
  align-items: center;
  height: ${spacing.x3};
`;

export const CardKeyText = styled.div`
  ${body2};
  font-weight: ${fontWeights.bold};
`;

export const CardValueText = styled.div`
  ${body1};
  color: ${colors.textPrimary};
`;
